import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BehaviorSubject, Subscription} from 'rxjs';

import {debounceTime, distinctUntilChanged, filter, map, tap,} from 'rxjs/operators';
import {DashboardService} from '../../services/dashboard.service';
import {CrudService} from '../../services/crud.service';
import {LocalStorageService} from '../../services/localStorage.service';
import { ToastrService } from 'ngx-toastr';
import createInteractiveVideoData from 'src/app/afterLogin/createInteractiveVideo/createInteractiveVideo.data';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { VoiceModalComponent } from '../modals/voice-modal/voice-modal.component';

declare var $;

@Component({
  selector: 'app-new-header',
  templateUrl: './new-header.component.html',
  styleUrls: ['./new-header.component.css'],
})
export class NewHeaderComponent implements OnInit, OnDestroy, AfterViewInit {
  subscription: Subscription;
  notifications: any[] = [];
  searchOnGroup: any[] = [];
  searchbygroup: any[] = [];
  searchbyuser: any[] = [];
  searchdata: any[] = [];
  @ViewChild('dropdownContent') dropdownContent: ElementRef;
  @ViewChild('myInput') myInput: ElementRef;
  @Input() headerWithProfileIcon = false;
  @Input() headerWithLocalSearch = false;
  @Output() searchValue = new EventEmitter<string>();

  //WC 05182025 --- For search by voice
  @ViewChild('mySearchInput') mySearchInput!: ElementRef;

  searchChange$ = new BehaviorSubject('');
  isSearching = false;
  userData: any;
  isLoggedIN = false;
  noOfShoppingCartItems = 0;
  noOfShoppingCarts = 0;
  shoppingCarts: any;
  isSearchOpen = false;
  groupDetails: any;

  isVideoPage = false;
  isGroupPage = false;
  isLibraryPage = false;
  isFollowersPage = false;
  isFollowingPage = false;
  isCommunityPage = false;
  isBadgePage = false;
  isGroupDetailPage = false;
  isProfilePage = false;
  isSaveNodePage = false;
  isLeadPage = false;
  isGroupPlayListPage = false;
  isGroupAnalyticsPage = false;

  activePage = '';
  searchOnPage = {
    groupPage: false,
    myVideoPage: false,
    libraryPage: false,
    createInteractiveVideoPage: false
  }
  isDisplaySearchInput:boolean = false;
  @Input() searchTerm = '';
  toggleRender: any;
  isCreateInteractiveVideoPage:boolean = false;
  communityUrl:any
  env:any = environment
  coBrandingLogo:any;
  isPersonalize:any;
  userObject: any;
  player: any;
  isPlayListEmbedded = false;
  isNoLogo = false;

  options = {
    controls: true,
    width: 600,
    height: 80,
    plugins: {
      wavesurfer: {
        backend: 'WebAudio',
        waveColor: '#36393b',
        progressColor: 'black',
        debug: false,
        cursorWidth: 1,
        hideScrollbar: true
      },
      record: {
        audio: true,
        video: false,
        maxLength: 60,
        debug: true
      }
    }
  };

  isRecording = false;
  mediaRecorder: any;
  audioChunks: any[] = [];
  audioUrl: string | null = null;
  audioContext: AudioContext | null = null;
  analyser: AnalyserNode | null = null;
  dataArray: Uint8Array | null = null;
  animationId: any;
  stream: MediaStream | null = null;
  isListeningPrompt = true;
  isVoiceSearch: boolean = false;
  spinner: boolean = false;
  isShowMicroPhone: boolean = false;
  
  get searchPlaceholder() {
    // if (this.searchOnPage.groupPage) {
    //   return 'Search in ' + (this.groupDetails?.groupName || 'group');
    // }

    if ((this.isVideoPage && this.activePage === 'published') || this.router.url.includes("videoType")) {
      return "AI-powered search for the published content trees. You can now describe what you're looking for.";
    }
    if (this.isVideoPage && this.activePage === 'draft') {
      return "Search draft content";
    }
    if (this.isVideoPage && this.activePage === 'collab') {
      return "Search collab content";
    }
    if (this.isVideoPage && this.activePage === 'groups') {
      return "Search group shared content";
    }
    if (this.searchOnPage.createInteractiveVideoPage) {
      return 'Search tree content';
    }
    if (this.isLibraryPage) {
      return 'Search library';
    }
    if (this.isGroupPage || this.router.url.includes("groupType")) {
      return 'Search groups';
    }
    if (this.isBadgePage) {
      return 'Search badges';
    }
    if (this.isProfilePage || this.router.url.includes("userType")) {
      return 'Search usernames in FreeFuse to follow them';
    }
    if (this.isCommunityPage || this.router.url.includes("communityType")) {
      return 'Search communities';
    }
    if (this.isGroupDetailPage) {
      return 'Search group content';
    }
    if (this.isGroupPlayListPage) {
      //return 'Search group playlist';
       return "AI-powered search for the group playlist. You can now describe what you're looking for."
    }
    if (this.isGroupAnalyticsPage) {
      return 'Search videos';
    }
    if (this.isFollowersPage || this.router.url.includes("followerType")) {
      return 'Search followers';
    }
    if (this.isFollowingPage || this.router.url.includes("followingType")) {
      return 'Search following';
    }
    if (this.isSaveNodePage) {
      return 'Search saved nodes';
    }
    if (this.isLeadPage) {
      return 'Search lead emails';
    }
    return 'Search';
  }

  constructor(
      private readonly router: Router,
      private readonly crudService: CrudService,
      private readonly dashboardService: DashboardService,
      private readonly localStorageService: LocalStorageService,
      private activeRoute: ActivatedRoute,
      private toaster: ToastrService,
      private dialog: MatDialog,
      private cdRef: ChangeDetectorRef
  ) {

    // this.isDisplaySearchInput = ['/login', '/signup', '/forgotPassword', '/resetPassword', '/upload-videos', '/settings', '/integrations', '/group-completion/'].includes(this.router.url.split('?')[0]);
    this.isPersonalize = this.localStorageService.getItem('isPersonalize');

    this.isDisplaySearchInput = [
      '/login', '/signup', '/forgotPassword', '/resetPassword', '/upload-videos', '/settings', '/integrations', '/videos', '/questionnaires-dashboard-details', '/aiAgents'
    ].includes(this.router.url.split('?')[0]) ||
      /^\/(group-completion|group-detail|questionnaires-dashboard)\/[^/]+/.test(this.router.url.split('?')[0]);

    if (this.router.url.includes("create-interactive-video") || this.router.url.includes("new-create-interactive-video")){
      this.isCreateInteractiveVideoPage = true;
      this.searchOnPage.createInteractiveVideoPage = true
    }

    let urlSegment = window.location.pathname.split('/')[1];
    urlSegment = urlSegment.replace('-', '_');
    let coBrandingLogo = urlSegment + '_coBrandingLogo';

    // Check if the environment variable exists
    if (this.env[coBrandingLogo]) {
        this.coBrandingLogo = this.env[coBrandingLogo];
    }

    this.dashboardService.setSearchTerm = '';

  }

  ngOnInit(): void {
    this.isVideoPage = this.router.url === '/my-videos' || this.router.url.includes('/my-videos');
    this.isLibraryPage = this.router.url === '/library' || this.router.url.includes('/library');
    this.isGroupPage = this.router.url === '/my-groups' || this.router.url.includes('/my-groups');
    this.isBadgePage = this.router.url === '/badges' || this.router.url.includes('/badges');
    this.isFollowersPage = this.router.url === '/followers' || this.router.url.includes('/followers');
    this.isFollowingPage = this.router.url === '/following' || this.router.url.includes('/following');
    this.isProfilePage = this.router.url === '/profile' || this.router.url.includes('/profile');
    this.isSaveNodePage = this.router.url === '/saved-nodes' || this.router.url.includes('/saved-nodes');
    this.isLeadPage = this.router.url === '/leads' || this.router.url.includes('/leads');
    this.isCommunityPage = this.router.url === '/my-community' || this.router.url.includes('/my-community') || this.router.url === '/staaj-health' || this.router.url.includes('/staaj-health');
    this.isGroupDetailPage = this.router.url === '/community' || this.router.url.includes('/community') || this.router.url === '/my-group' || this.router.url.startsWith('/my-group/');
    this.isGroupPlayListPage = this.router.url === '/playlist' || this.router.url.includes('/playlist');
    this.isGroupAnalyticsPage = this.router.url === '/group-analytics' || this.router.url.includes('/group-analytics');

    //WC 05232025 --- Removed microphone from isGroupDetailPage for now
    //this.isShowMicroPhone = (this.isVideoPage && this.activePage === 'published') || this.isGroupDetailPage || this.isGroupPlayListPage
    this.isShowMicroPhone = (this.isVideoPage && this.activePage === 'published') || this.isGroupPlayListPage

    this.activeRoute.queryParams.subscribe(params => {
      this.searchTerm = params.search;
      this.toggleRender = params.render;

      //WC 05092025 -- Example of the iFramed Group Playlist URL
      //<iframe allowfullscreen frameborder="0" width="100%" height="800" src="https://freefuse.com/playlist?groupId=68151be9e48dedfa5c2e90b4&embed=true&noLogo=true”></iframe>

      if (
        this.router.url.startsWith('/playlist') && params['embed'] === 'true'
      ) {
        this.isPlayListEmbedded = true;

        this.isNoLogo = params['noLogo'];
        
      } 
    });

    this.dashboardService.getActivePage.subscribe((res) => {
      this.activePage = res;
      //this.isShowMicroPhone = (this.isVideoPage && this.activePage === 'published') || this.isGroupDetailPage || this.isGroupPlayListPage
      this.isShowMicroPhone = (this.isVideoPage && this.activePage === 'published') || this.isGroupPlayListPage
      // this.searchTerm = ''
    });
    
    if (this.localStorageService.getItem('user') && this.localStorageService.getItem('token')) {
      this.isLoggedIN = true;
      this.getUserData();
    }

    // this.dashboardService.getGroupDetails.subscribe((res) => {
    //   this.groupDetails = res;
    //   if (!this.groupDetails) {
    //     this.searchOnPage.groupPage = false;
    //   }
    // });

    if (this.isLoggedIN) {
      this.subscription = this.crudService.notifications.subscribe((res) => {
        // alert(res)
        this.getNotificationData();
      });

      this.subscription = this.dashboardService.getShoppingCarts.subscribe((res) => {

        // console.log("new-header --- dashboardService.getShoppingCarts = ", res);

        if (res && res.length) {
          this.shoppingCarts = res;
          this.noOfShoppingCarts = res.length;
          // console.log("this.noOfShoppingCarts = ", this.noOfShoppingCarts);
        }
      });

      // console.log("this.headerWithProfileIcon = ", this.headerWithProfileIcon);

      if (this.headerWithProfileIcon) {
        // console.log("getting getUserData");

        this.subscription = this.dashboardService.getUserData.subscribe((res) => {
          if (res) {
            this.userData = res;
            // console.log("this.userData = ", this.userData);
          }
        });
      }
    }
  }

  viewNotification(id: any) {
    for (const i of this.notifications) {
      if (id === i.notificationId) {
        if (i.notificationType === 'follow') {
          this.router.navigate(['/public-profile'], {queryParams: {user: i.userInfo._id}});
        } else if (i.notificationType === 'contributor') {
          this.router.navigate(['/create-interactive-video'], {queryParams: {video: i.videoInfo._id}});
        } else if (i.notificationType === 'publishVideo') {
          this.router.navigate(['/videos'], {queryParams: {video: i.videoInfo._id}});
        } else if (i.notificationType === 'Comment') {
          this.router.navigate(['/videos'], {queryParams: {video: i.videoInfo._id}});
        } else if (i.notificationType === 'Like') {
          this.router.navigate(['/videos'], {queryParams: {video: i.videoInfo._id}});
        } else if (i.notificationType === 'collab') {
          const queryParams: any = {
            video: i.videoInfo?.childVideoId ? i.videoInfo?.childVideoId : i.videoInfo._id,
            comment: i.category.id,
            requester: i.category.userID,
          }
          if (!this.toggleRender) {
            queryParams.render = true;
          }
          this.router.navigate(['/my-group', i.category.activityTypeID], {queryParams});
        } else if (i.notificationType === 'mainCommunityCollab') {
          const queryParams: any = {
            video: i.videoInfo?.childVideoId ? i.videoInfo?.childVideoId : i.videoInfo._id,
            comment: i.category.id,
            requester: i.category.userID,
          }
          if (!this.toggleRender) {
            queryParams.render = true;
          }
          if (i.sellerInfo?.business?.communityUrl) {
            // this.router.navigate(['/main-community', i.sellerInfo?.business?.communityUrl], {queryParams});
            this.router.navigate(['/my-community', i.sellerInfo?.business?.communityUrl], {queryParams});
          } else {
            queryParams.user = i.sellerInfo._id;
            // this.router.navigate(['/main-community'], {queryParams});
            this.router.navigate(['/my-community'], {queryParams});
          }
        } else if (i.notificationType === 'videoPlayerCollab') {
          const queryParams: any = {
            video: i?.mainVideoInfo?._id,
            collabVideo: i.videoInfo?.childVideoId ? i.videoInfo?.childVideoId : i.videoInfo._id,
            comment: i.category.id,
            requester: i.category.userID,
          }
          if (!this.toggleRender) {
            queryParams.render = true;
          }
          this.router.navigate(['/videos'], {queryParams});
        } //WC 08082023 -- Adding video player collab respons
        else if (i.notificationType === 'videoPlayerCollabResponse') {
          const queryParams: any = {
            video: i?.videoInfo?._id,
          }
          if (!this.toggleRender) {
            queryParams.render = true;
          }

          // console.log("navigating with queryParams = ", queryParams);
          this.router.navigate(['/videos'], {queryParams});
        } else if (i.notificationType === 'mainCommunityShare') {
          if (i.sellerInfo?.business?.communityUrl) {
            this.router.navigate(['/my-community', i.sellerInfo?.business?.communityUrl]);
          } else {
            const queryParams = {user: i.sellerInfo._id};
            this.router.navigate(['/my-community'], {queryParams});
          }
        } else {
          this.router.navigate(['/videos'], {queryParams: {video: i.videoInfo._id}});
        }
      }
    }
  }

  checkout() {
    if (this.router.url.indexOf('/checkout') !== -1 || this.router.url.indexOf('/community-checkout') !== -1) {
      window.location.reload()
    } else {
      // Check if we have only FreeFuse shopping cart which is the shopping cart with no userId
      if (this.shoppingCarts.length == 1 && (this.shoppingCarts[0].groupId == undefined)) {
        this.localStorageService.setItem('shoppingCartId', this.shoppingCarts[0]._id);
        this.router.navigate(['checkout'], {queryParams: {subscription_clientSecret: this.localStorageService.getItem('clientSecret')}});
      } else
        this.router.navigate(['community-checkout']);
    }

  }

  onClickMenu() {
    this.dashboardService.onClickMobileMenu(true);
  }

  getUserData() {
    this.crudService.userDetailsV2().subscribe(success => {
      this.userObject = success.data.details;
    })
  }
  removeSearchText(){
    this.searchTerm = '';
    this.searchValue.emit(this.searchTerm);

    this.isDropdownVisible = false
    this.dashboardService.setSearchTerm = '';
    if (this.router.url.includes('/search-results') && this.router.url.includes("videoType")) {
      this.router.navigate(['/my-videos']);
    }
    if (this.router.url.includes('/search-results') && this.router.url.includes("groupType")) {
      this.router.navigate(['/my-groups']);
    }
    if (this.router.url.includes('/search-results') && this.router.url.includes("userType")) {
      this.router.navigate(['/profile']);
    }
    if (this.router.url.includes('/search-results') && this.router.url.includes("followerType")) {
      this.router.navigate(['/followers']);
    }
    if (this.router.url.includes('/search-results') && this.router.url.includes("followingType")) {
      this.router.navigate(['/following']);
    }
    if (this.router.url.includes('/search-results') && this.router.url.includes("communityType")) {
      this.router.navigate(['/my-community', this.userObject?.business?.communityUrl]);
    }
  }

  onChangeSearchValue(event: any) { 
    let value = event.target.value;
    let trimValue = value.trim();
    if (!trimValue) {
      this.removeSearchText();
    }
  }

  onSearchValue(event: any) {
    let value = event.target.value;
    let trimValue = value.trim();
    if (event.key === 'Enter' && !trimValue) {
      this.toaster.error('Please enter a search term');
    }

    if (!trimValue) {
      this.dashboardService.setSearchTerm = value;
      this.searchValue.emit(event.target.value);
      return;
    }
    
    this.searchTerm = value.replace(/^\s+/, ''); 

    if (this.isVoiceSearch) {
      this.dashboardService.setSearchTerm = value;
      // this.spinner = false
    }

    if (this.isVideoPage && this.activePage === 'published' && this.isVoiceSearch === false) {
      this.dropdownContent.nativeElement.style.display = 'block';
      return;
    }

    if (this.isGroupPage) {
      this.dropdownContent.nativeElement.style.display = 'block';
      return;
    }

    if (this.isSaveNodePage || this.isLeadPage) {
      this.dashboardService.setSearchTerm = value;
      return;
    }

    if (this.router.url.includes("videoType")) {
      this.router.navigate(['/search-results'], { queryParams: { search: this.searchTerm.trim(), videoType: 'all' } });
      return;
    }

    if (this.router.url.includes("groupType")) {
      this.router.navigate(['/search-results'], { queryParams: { search: this.searchTerm.trim(), groupType: 'all' } });
      return;
    }

    if (this.isCommunityPage || this.router.url.includes("communityType")) {
      this.router.navigate(['/search-results'], { queryParams: { search: this.searchTerm.trim(), communityType: 'all' } });
      return;
    }

    //WC - 102424 Removed this restriction as it's causing search to failconsole.log();
    //WC -- To prevent chars which will cause any issue with MongoDB
    // const regex = /^[a-zA-Z0-9 _-]*$/; // Allows letters, numbers, spaces
    // if (!regex.test(value)) {
    //   this.toaster.error('Invalid input detected. Please enter only letters, numbers, and spaces');
    //   return;
    // }

    if (!this.headerWithLocalSearch) {
      this.searchChange$.next(value);
    } else {
      this.dashboardService.setSearchTerm = value;
      this.searchValue.emit(event.target.value);
    }

    if (!this.isVideoPage && !this.isGroupPage && !this.isBadgePage && !this.isLibraryPage && !this.isCreateInteractiveVideoPage && !this.isGroupDetailPage && !this.isGroupPlayListPage && !this.isGroupAnalyticsPage) {      
      this.gotoSearch(value);
    }

    this.dashboardService.setSearchTerm = value;
    this.isVoiceSearch = false;
    // tslint:disable-next-line: no-string-literal
    // this.searchChange$.next(event.target.value);
    // if (!this.headerWithLocalSearch) {
    //   this.searchChange$.next(value);
    // } else {
    //   this.dashboardService.setSearchTerm = value;
    //   this.searchValue.emit(value);
    // }

    // this.gotoSearch(value);
  }

  @HostListener('document:click', ['$event.target'])
  onClick(targetElement) {
    try {
      const clickedInside = this.myInput.nativeElement.contains(targetElement);
      if (!clickedInside) {
        this.onBlurInput();
      }
    } catch (err) {

    }
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      if (!this.isDropdownVisible) {
        this.isDropdownVisible = true; // Open dropdown on first Enter press
      } else {
        // If dropdown is visible, trigger the selected function
        if (this.activeOption === 0 && this.isVideoPage) {
          this.toggleIsSearchVideoPage(true);
        } else if (this.activeOption === 1 && this.isVideoPage) {
          this.toggleIsSearchVideoPage(false);
        } else if (this.activeOption === 0 && this.isGroupPage) {
          this.handleClick(true);
        } else if (this.activeOption === 1 && this.isGroupPage) {
          this.handleClick(false);
        }
      }
    }
  }

  recordedAudio: any;

  ngAfterViewInit() {
    try {

      this.searchChange$
          .asObservable()
          .pipe(
              filter(Boolean),
              debounceTime(1500),
              distinctUntilChanged(),
              tap((event) => {
                // this.onSearchItem(event);
              })
          )
          .subscribe();
      // this.dropdownContent.nativeElement.onclick = () => console.log('clicked');
    } catch (err) {
      // search component is hidden
    }
  }

  toggleIsSearchGroupPage(i) {
    this.searchOnPage.groupPage = i;
    this.onSearchItem(this.searchTerm);
  }

  handleClick(isSearchGroup: boolean) {
    this.searchOnPage.groupPage = isSearchGroup;
    this.onSearchItem(this.searchTerm);
  }


  toggleIsSearchVideoPage(i) {
    this.searchOnPage.myVideoPage = i;
    this.onSearchItem(this.searchTerm);
  }

  toggleIsSearchLibraryPage(i) {
    this.searchOnPage.libraryPage = i;
    if (i) {
      this.searchbygroup = [];
      this.searchbyuser = [];
      this.searchdata = [];
      this.searchOnGroup = [];
      this.headerWithLocalSearch = true;
      this.dashboardService.setSearchTerm = this.searchTerm;
    } else {
      this.headerWithLocalSearch = false;
      this.onSearchItem(this.searchTerm);
      this.dashboardService.setSearchTerm = '';
    }
  }

  onSearchItem(text: any) {
    // this.isSearching = true;
    this.searchbygroup = [];
    this.searchbyuser = [];
    this.searchdata = [];
    this.searchOnGroup = [];
    this.isDropdownVisible = false

    if (this.isGroupPage) {

      if (this.searchOnPage.groupPage) {
        this.dashboardService.setSearchTerm = text;
        return
      }

      this.router.navigate(['/search-results'], { queryParams: { search: this.searchTerm.trim(), groupType: this.searchOnPage.groupPage ? 'ownGroups' : 'all' } });
      // this.subscription = this.crudService.searchGroupNode(text, this.groupDetails._id).subscribe(
      //     (response) => {
      //       this.isSearching = false;
      //       this.searchOnGroup = response.data;
      //     },
      //     (error) => (this.isSearching = false)
      // );
    } else if (this.isCommunityPage) {
      this.dashboardService.setSearchTerm = text;
      this.router.navigate(['/search-results'], { queryParams: { search: this.searchTerm.trim(), communityType: 'all' } });
    }
    else {
      const params: any = {
        word: text,
        limit: 3,
        skip: 0,
        searchType: 'all',
      }
      if (this.isVideoPage && this.searchOnPage.myVideoPage) {
        
        // params.searchType = 'ownVideos';
        if (this.activePage === 'draft') {
          params.isPublished = false;
        }
        this.dashboardService.setSearchTerm = text;

        return;
      }
      
      this.router.navigate(['/search-results'], { queryParams: { search: this.searchTerm.trim(), videoType: 'all' } });
      
      return
      this.subscription = this.crudService.searchVideo(params).subscribe(
          (response) => {
          this.isSearching = false;
          this.onBlurInput();
          this.searchbygroup = response.data.result.searchbygroup || [];
          this.searchbyuser = response.data.result.searchbyuser || [];
          this.searchdata = response.data.result.searchdata || [];
          },
          (error) => (this.isSearching = false)
      );
    }
  }

  gotoUser(id: any) {
    this.onBlurInput();
    // console.log('gotoUser');
    this.router.navigate(['public-profile'], {queryParams: {user: id}});
  }

  gotoGroup(id: any) {
    this.onBlurInput();
    if (!this.localStorageService.getItem('token')) {
      this.router.navigate(['login']);
      this.localStorageService.setItem('grpId', id);
    } else {
      this.router.navigate(['/my-group/' + id]);
    }
  }

  gotoSearch(search: any) {
    this.onBlurInput();

    if (this.isProfilePage || this.router.url.includes("userType")) {
      this.dashboardService.setSearchTerm = search;
      this.router.navigate(['/search-results'], { queryParams: { search: this.searchTerm.trim(), userType: 'all' } });
      return;
    }
    
    if (this.isFollowersPage || this.router.url.includes("followerType")) {
      this.dashboardService.setSearchTerm = search;
      this.router.navigate(['/search-results'], { queryParams: { search: this.searchTerm.trim(), followerType: 'all' } });
      return;
    }

    if (this.isFollowingPage || this.router.url.includes("followingType")) {
      this.dashboardService.setSearchTerm = search;
      this.router.navigate(['/search-results'], { queryParams: { search: this.searchTerm.trim(), followingType: 'all' } });
      return;
    }    

    this.router.navigate(['/search-results'], {queryParams: {search}});
  }

  gotoVideo(id: any) {
    this.onBlurInput();
    this.router.navigate(['/videos'], {queryParams: {video: id}});
  }

  onFocusInput() {
    if (this.dropdownContent) {
      this.dropdownContent.nativeElement.style.display = 'none';
    }
  }

  onBlurInput() {
    setTimeout(() => {
      if (this.dropdownContent) {
        this.dropdownContent.nativeElement.style.display = 'none';
      }
    }, 500);
  }

  onClickCreateNewVideos() {
    this.router.navigate(['/upload-videos']);
  }

  viewAllNotifications() {
    this.router.navigate(['/notifications']);
  }

  getNotificationData() {
    const type: any = 'notViewed';
    this.subscription = this.crudService
      .getNotificationsV2(type, 6, 1)
      .pipe(
        map((notifications) => {
          if (!notifications.data || !Array.isArray(notifications.data)) {
            return {notification: []};
          }
          return {
            notification: notifications.data.map((noti) => {
              return {
                show: this.getNotificationType(noti),
                ...noti,
              };
            }),
          };
        })
      )
      .subscribe((response) => {
        this.notifications = response.notification;
      });
  }

  getNotificationType(noti) {
    const userName = noti?.userInfo?.username;
    const videoInfo = noti?.videoInfo?.Title ? noti.videoInfo.Title : (noti?.videoInfo?.name ? noti?.videoInfo?.name : 'new video');
    let returnString = ``;
    const notificationType = noti.notificationType;
    if (notificationType === 'choice' && noti.videoInfo) {
      returnString = `${userName} chose ${noti.videoInfo.childInfo} on ${videoInfo}`;
    } else if (notificationType === 'Emphasised') {
      returnString = `${userName} emphasized on ${videoInfo}`;
    } else if (notificationType === 'Question') {
      returnString = `${userName} questioned on ${videoInfo}`;
    } else if (notificationType === 'Comment') {
      returnString = `${userName} commented on ${videoInfo}`;
    } else if (notificationType === 'Like') {
      returnString = `${userName} reacted on ${videoInfo}`;
    } else if (notificationType === 'Share') {
      returnString = `${userName} shared ${videoInfo}`;
    } else if (notificationType === 'follow') {
      returnString = `${userName} started following you`;
    } else if (notificationType === 'publishVideo') {
      returnString = `${userName} published ${videoInfo}`;
    } else if (notificationType === 'contributor') {
      returnString = `${userName} added you as a contributor for ${videoInfo}`;
    } else if (notificationType === 'remove contributor') {
      returnString = `${userName} removed you as a contributor for ${videoInfo}`;
    } else if (notificationType === 'collab') {
      returnString = `${userName} requested you to respond to ${videoInfo}`
    } else if (notificationType === 'mainCommunityCollab') {
      returnString = `${userName} requested you to respond to ${videoInfo}`
    } else if (notificationType === 'videoPlayerCollab') {
      const mainVideoInfo = noti?.mainVideoInfo?.Title ? noti.mainVideoInfo.Title : 'new video';
      returnString = `${userName} requested you to respond to video collab in ${videoInfo}`
    } else if (notificationType === 'videoPlayerCollabResponse') {
      const mainVideoInfo = noti?.mainVideoInfo?.Title ? noti.mainVideoInfo.Title : 'new video';
      returnString = `${userName} has responded to your video collab request in ${videoInfo}`
    } else if (notificationType === 'mainCommunityShare') {
      const sellerName = noti?.sellerInfo ? (noti?.sellerInfo?.firstname + ' ' + noti?.sellerInfo?.lastname) : 'community';
      const sellerInfo = noti?.sellerInfo?.business?.name ? noti?.sellerInfo?.business?.name : sellerName;
      returnString = `${userName} is inviting you to join ${sellerInfo}`
    } else if (notificationType === 'transferVideoOwnership') {
      returnString = `${userName} transferred ownership of ${videoInfo} to you`
    }
    return returnString;
  }

  redirect() {

    if (this.localStorageService.getItem('isSubscriber') === 'true') {
      if (this.localStorageService.getItem('interactive') === 'isTemplate') {
        this.localStorageService.setItem('interactive', 'isInteractive')
        location.reload();
      } else {
        this.router.navigate(['upload-videos']);
      }
    } else {
      if (this.userData?.planName === null || this.userData?.planName === undefined) {
        document.getElementById('becomeCreator').click();
      } else {
        this.router.navigate(['pricing']);
      }
    }

  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onClickSearch() {
      this.isSearchOpen = !this.isSearchOpen;
  } 

  activeOption: number = 0; // 0: Search my own videos, 1: Search Freefuse videos
  isDropdownVisible = false;

  // Change the active option based on the arrow key pressed
  changeActiveOption(direction: string): void {
    if (direction === 'up') {
      this.activeOption = this.activeOption === 0 ? 1 : 0; // Toggle between 0 and 1
    } else if (direction === 'down') {
      this.activeOption = this.activeOption === 1 ? 0 : 1; // Toggle between 0 and 1
    }
  }
  // Change active option on mouse hover
  setActiveOption(option: number): void {
    this.activeOption = option;
  }
  handleEnterKey(isVideoSearch: boolean) {
    if (!this.isDropdownVisible) {
      this.isDropdownVisible = true; // Open dropdown
    } else {
      // Once the dropdown is visible, toggle the active option
      if (this.activeOption === 0) {
        this.toggleIsSearchVideoPage(true);
      } else if (this.activeOption === 1) {
        this.toggleIsSearchVideoPage(false);
      }
    }
  }

  handleEnterKeyForGroup(isVideoSearch: boolean) {
    if (!this.isDropdownVisible) {
      this.isDropdownVisible = true; // Open dropdown
    } else {
      // Once the dropdown is visible, toggle the active option
      if (this.activeOption === 0) {
        this.handleClick(true);
      } else if (this.activeOption === 1) {
        this.handleClick(false);
      }
    }
  }

  triggerSearch() {
    const el = this.mySearchInput.nativeElement;
    const event = new KeyboardEvent('keyup', {
      key: 'Enter',
      code: 'Enter',
      keyCode: 13,
      which: 13,
      bubbles: true
    });
    el.dispatchEvent(event);
  }

  openVoiceModal() {
    this.isVoiceSearch = true;
    const dialogRef = this.dialog.open(VoiceModalComponent, {
      width: '100%',
      maxWidth: '500px',
      panelClass: 'voice-modal',
      height: 'auto',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.spinner = false;
      if (result) {
        // this.spinner = true;
        this.cdRef.detectChanges();
        this.searchTerm = result.searchTerm;
        this.onSearchValue({ target: { key: 'Enter', value: this.searchTerm } });
        this.cdRef.detectChanges();
      }
    });
  
  }

  async startVoiceRecording() {
    $('#voiceModal').modal('show');
   
    // console.log("in startVoiceRecording");

    try {
      this.audioChunks = [];

      //Requesting microphone access
      this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });

      //const mimeType = 'audio/webm';
      const mimeType = 'audio/webm; codecs=opus';
      if (!MediaRecorder.isTypeSupported(mimeType)) {
        this.toaster.error(`Your browser does not support the required audio format of ${mimeType}`);
        return;
      }

      this.mediaRecorder = new MediaRecorder(this.stream, { mimeType });
  
      this.mediaRecorder.ondataavailable = (event: BlobEvent) => {
        if (event.data.size > 0) {
          this.audioChunks.push(event.data);
        }
      };
  
      this.mediaRecorder.onstop = async () => {
         $('#voiceModal').modal('hide');
        
        // Finalize the recording
        const mimeType = 'audio/webm'; // Ensure it's declared or scoped appropriately
        const audioBlob = new Blob(this.audioChunks, { type: mimeType });
        this.audioUrl = URL.createObjectURL(audioBlob);
        this.stream.getTracks().forEach(track => track.stop());
        this.isRecording = false;
      
        // console.log('Recording complete, audio URL:', this.audioUrl);
      
        try {
          // Convert Blob to ArrayBuffer
          const arrayBuffer = await audioBlob.arrayBuffer();
      
          this.crudService.transcribeAudioStream(arrayBuffer).subscribe((response: any) => {
            // console.log('*** Transcription Response = ', response);
            this.searchTerm = response.data;
            // console.log('*** this.transcript = ', this.searchTerm);
      
            this.triggerSearch();

          }, (error: any) => {
            console.error('Error during transcription:', error);
          });
      
        } catch (err) {
          console.error('Error during transcription:', err);
        }
      };
  
      this.mediaRecorder.start();
      this.isRecording = true;
      this.isListeningPrompt = true;

      // Show "Listening..." for 1 second, then switch to "Speak now..."
      setTimeout(() => {
        this.isListeningPrompt = false;
      }, 1000);

      this.startVisualizer();
    } catch (err) {
      // console.log('in new-header.startVoiceRecording - err: ', err);
      this.isRecording = false;
      if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
        this.toaster.error('No microphone found. Please connect a microphone and try again.');
      } else if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
        this.toaster.error('Microphone access was denied. Please allow access and try again.');
      } else {
        this.toaster.error('An error occurred: ' + err.message);
      }
      $('#voiceModal').modal('hide');
    }
  }


  deepgramSocket: WebSocket | null = null;
  audioProcessor: any = null;

  // async startVoiceRecording() {
  //   $('#voiceModal').modal('show');
  //   this.transcript = '';
  //   const DG_API_KEY = environment.Deepgram_API_Key; // For demo/testing only!

  //   try {
  //     // Clean up any previous streams/contexts
  //     if (this.audioContext) {
  //       await this.audioContext.close();
  //       this.audioContext = null;
  //     }
  //     if (this.deepgramSocket && this.deepgramSocket.readyState === WebSocket.OPEN) {
  //       this.deepgramSocket.close();
  //     }

  //     this.audioChunks = [];
  //     this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  //     this.mediaRecorder = new MediaRecorder(this.stream);

  //     // --- Deepgram WebSocket Setup ---
  //     // For demo: API key in URL. For production, use a backend proxy!
  //     this.deepgramSocket = new WebSocket(
  //       `wss://api.deepgram.com/v1/listen?access_token=Token ${DG_API_KEY}&language=en&punctuate=true`
  //     );

  //     this.deepgramSocket.onopen = () => {
  //       // AudioContext at 16kHz for Deepgram
  //       this.audioContext = new (window.AudioContext || (window as any).webkitAudioContext)({ sampleRate: 16000 });
  //       const source = this.audioContext.createMediaStreamSource(this.stream!);
  //       this.audioProcessor = this.audioContext.createScriptProcessor(4096, 1, 1);

  //       source.connect(this.audioProcessor);
  //       this.audioProcessor.connect(this.audioContext.destination);

  //       this.audioProcessor.onaudioprocess = (e: AudioProcessingEvent) => {
  //         const input = e.inputBuffer.getChannelData(0);
  //         const int16Buffer = this.convertFloat32ToInt16(input);
  //         if (this.deepgramSocket && this.deepgramSocket.readyState === WebSocket.OPEN) {
  //           this.deepgramSocket.send(int16Buffer);
  //         }
  //       };
  //     };

  //     this.deepgramSocket.onmessage = (message: MessageEvent) => {
  //       const data = JSON.parse(message.data);
  //       if (data.channel?.alternatives?.length > 0) {
  //         const transcript = data.channel.alternatives[0].transcript;
  //         if (transcript && data.is_final) {
  //           this.transcript += transcript + '\n';
  //         }
  //       }
  //     };

  //     this.deepgramSocket.onerror = (err) => {
  //       console.error('Deepgram WebSocket error', err);
  //       this.toaster?.error?.('Live transcription unavailable.');
  //       this.stopRecording();
  //     };

  //     this.deepgramSocket.onclose = () => {
  //       console.log('Deepgram WebSocket closed');
  //     };

  //     // --- MediaRecorder for saving audio ---
  //     this.mediaRecorder.ondataavailable = (event: any) => {
  //       if (event.data.size > 0) {
  //         this.audioChunks.push(event.data);
  //       }
  //     };

  //     this.mediaRecorder.onstop = () => {
  //       const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
  //       this.audioUrl = URL.createObjectURL(audioBlob);
  //       this.stream?.getTracks().forEach(track => track.stop());
  //       this.isRecording = false;

  //       // Clean up Deepgram
  //       if (this.deepgramSocket && this.deepgramSocket.readyState === WebSocket.OPEN) {
  //         this.deepgramSocket.close();
  //       }
  //       if (this.audioProcessor) {
  //         this.audioProcessor.disconnect();
  //         this.audioProcessor = null;
  //       }
  //       if (this.audioContext) {
  //         this.audioContext.close();
  //         this.audioContext = null;
  //       }
  //     };

  //     this.mediaRecorder.start();
  //     this.isRecording = true;
  //     this.startVisualizer();

  //   } catch (err: any) {
  //     this.isRecording = false;
  //     this.toaster?.error?.('Microphone or transcription error: ' + err.message);
  //     $('#voiceModal').modal('hide');
  //   }
  // }

  // Helper for Deepgram
  // convertFloat32ToInt16(buffer: Float32Array): ArrayBuffer {
  //   const l = buffer.length;
  //   const int16 = new Int16Array(l);
  //   for (let i = 0; i < l; i++) {
  //     int16[i] = Math.max(-1, Math.min(1, buffer[i])) * 0x7FFF;
  //   }
  //   return int16.buffer;
  // }

  stopRecording() {
    // console.log("in stopRecording");

    if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
      this.mediaRecorder.stop();
    }
    this.isRecording = false;
    // if (this.deepgramSocket && this.deepgramSocket.readyState === WebSocket.OPEN) {
    //   this.deepgramSocket.close();
    // }
    if (this.audioProcessor) {
      this.audioProcessor.disconnect();
      this.audioProcessor = null;
    }
    if (this.audioContext) {
      this.audioContext.close();
      this.audioContext = null;
    }
  }

  closeModal() {
    if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
      this.mediaRecorder.stop();
    }

    this.isRecording = false;
    this.audioUrl = null;
    this.searchTerm = '';

    if (this.deepgramSocket && this.deepgramSocket.readyState === WebSocket.OPEN) {
      this.deepgramSocket.close();
    }
    if (this.audioProcessor) {
      this.audioProcessor.disconnect();
      this.audioProcessor = null;
    }
    if (this.audioContext) {
      this.audioContext.close();
      this.audioContext = null;
    }
    $('#voiceModal').modal('hide');
  }


  // --- Waveform Visualizer Methods ---
  startVisualizer() {
    if (!this.stream || !this.audioContext) return;
    const source = this.audioContext.createMediaStreamSource(this.stream);
    this.analyser = this.audioContext.createAnalyser();
    source.connect(this.analyser);
    this.analyser.fftSize = 256;
    const bufferLength = this.analyser.frequencyBinCount;
    this.dataArray = new Uint8Array(bufferLength);
    // You can add visualization logic here
  }


  resetRecording() {
    // Stop any ongoing recording
    this.mediaRecorder.stop();
    // if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
    // }

    // Reset audio chunks and audio URL
    this.audioChunks = [];
    this.audioUrl = null;
    this.isRecording = false;

    // Start fresh recording
    this.startVoiceRecording();
  }

}
